module.exports = __webpack_public_path__ + "img/dreamweavers-2.dd19ceec.webp";